/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Grid } from "@mui/material";
import PDialog from "../../components/pos/PDialog";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUploadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import PText from "../../components/pos/PText";

export default function PFileDropZone(props) {
  const { t } = useTranslation();
  const translate = t;
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
  const [isSaveLoaderEnabled, setIsSaveLoaderEnabled] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*,.pdf",
    onDrop: (acceptedFiles) => {
      setIsLoaderEnabled(true);
      let promises = [];
      acceptedFiles.map((fileItem) => {
        /*Checking file size limits default 2MB*/
        let fileSize = (fileItem.size / (1024 * 1024)).toFixed(2);
        if (fileSize > (props.maxSize ? props.maxSize : 2)) {
          props.showMessage(
            "error",
            "File Size Limit Exceeded " + fileItem.name
          );
        } else {
          promises.push(
            new Promise((resolve, reject) => {
              let previewObj = null;
              let fileReader = new FileReader();
              fileReader.onload = function (fileLoadedEvent) {
                previewObj = fileLoadedEvent.target.result;
                let fileType = "DOCUMENT";
                if (fileItem.type.includes("image")) {
                  fileType = "IMAGE";
                }
                let fileObj = {
                  index: null,
                  file: fileItem,
                  fileTypeText: fileItem.type,
                  previewObj: previewObj,
                  selected: false,
                  fileType: fileType,
                  fileName: fileItem.name,
                  fileExtension: fileItem.name.split(".").pop(),
                };
                resolve(fileObj);
              };
              // Convert data to base64
              fileReader.readAsDataURL(fileItem);
            })
          );
        }
      });
      Promise.all(promises).then((content) => {
        let tempFilesList = [...files];
        content.map((fileItem) => {
          fileItem.index = tempFilesList.length;
          tempFilesList.push(fileItem);
        });
        setIsLoaderEnabled(false);
        setFiles(tempFilesList);
      });
    },
  });

  function onCloseWindow() {
    setFiles([]);
    setSelectedFile(null);
    props.setOpenWindow(false);
  }

  function handleSave() {
    if (files.length > 0) {
      props.handleFileSave(files);
      setFiles([]);
      setSelectedFile(null);
      props.setOpenWindow(false);
    } else {
      props.showMessage("error", "Please select any file before proceed");
    }
  }

  function handleRemoveSelected() {
    let tempFilesList = [...files];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < tempFilesList.length; i++) {
      if (selectedFile != i) {
        tempFilesList[i].index = index;
        updatedList.push(tempFilesList[i]);
        index++;
      }
    }
    setFiles(updatedList);
    setSelectedFile(null);
  }

  function changeSelection(fileIndex) {
    let tempFilesList = [...files];
    for (let i = 0; i < tempFilesList.length; i++) {
      tempFilesList[i].selected = false;
    }
    tempFilesList[fileIndex].selected = true;
    setFiles(tempFilesList);
    setSelectedFile(fileIndex);
  }

  function handleNameChangeEvent(fileIndex, newFileName) {
    let tempFilesList = [...files];
    tempFilesList[fileIndex].fileName = newFileName;
    setFiles(tempFilesList);
  }

  const content = (
    <div>
      <Grid
        container
        {...getRootProps({ className: "dropzone" })}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item xs={4}>
          <CloudUploadIcon
            style={{ width: "200px", height: "200px", color: "#c9c5c5" }}
          />
        </Grid>
        <Grid item xs={12}>
          <input {...getInputProps()} />
          <p>Drag drop some files here, or click to select files</p>
        </Grid>
      </Grid>
      <hr />
      <Grid container>
        {files.map((fileItem) => (
          <Grid item xs={3} key={fileItem}>
            {fileItem.fileType == "IMAGE" ? (
              <table width="100%">
                <tr>
                  <div
                    style={{
                      borderStyle: fileItem.selected ? "solid" : "dotted",
                      marginLeft: "10px",
                      marginTop: "5px",
                    }}
                    onClick={() => changeSelection(fileItem.index)}
                  >
                    <img
                      src={fileItem.previewObj}
                      style={{ width: "100%", height: "100px" }}
                      alt=""
                    />
                  </div>
                </tr>
                <tr>
                  <PText
                    style={{ marginTop: "5px" }}
                    value={fileItem.fileName}
                    onChange={(e) =>
                      handleNameChangeEvent(fileItem.index, e.target.value)
                    }
                  ></PText>
                </tr>
              </table>
            ) : (
              <table width="100%">
                <tr>
                  <div
                    style={{
                      borderStyle: fileItem.selected ? "solid" : "dotted",
                      marginLeft: "10px",
                      marginTop: "5px",
                    }}
                    onClick={() => changeSelection(fileItem.index)}
                  >
                    <PictureAsPdfOutlinedIcon
                      style={{
                        width: "100%",
                        height: "100px",
                        color: "#084675",
                      }}
                    />
                  </div>
                </tr>
                <tr>
                  <PText
                    style={{ marginTop: "5px" }}
                    value={fileItem.fileName}
                    onChange={(e) =>
                      handleNameChangeEvent(fileItem.index, e.target.value)
                    }
                  ></PText>
                </tr>
              </table>
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  );

  return (
    <div>
      {props.openWindow && (
        <PDialog
          content={content}
          title={translate("File Seletor")}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={handleSave}
          saveLabel={"Save Files"}
          removeSelected={selectedFile != null ? true : false}
          onRemoveSelected={handleRemoveSelected}
          isSaveLoaderEnabled={isSaveLoaderEnabled}
          mode={"create"}
          isLoaderEnabled={isLoaderEnabled}
        ></PDialog>
      )}
    </div>
  );
}
